<div class="top-bar">
  <div class="container-fluid">
    <div class="top-bar p-1 border16 topbar">
      <div class="row">
        <div class="col-md-12 text-end">
          <!-- <span class="toplocation" style="color: #fff;" *ngIf="currentlocation?.city && currentlocation?.state">
            
            <img style="filter: invert(1);" src="assets/images/locations.svg" alt="location" class="img-fluid">
            {{currentlocation?.city}},
            {{currentlocation?.state}}
          </span> -->
          <a href="tel:+9196079 25900" class="colorwhite me-3"><img src="assets/images/new_img/call.svg"
              class="callicon" alt=""> +91 96079 25900</a>
          <button type="button" class="btn colorwhite topEnquiry" (click)="enquiry()"> Post Your Enquiry</button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="boxhead">
  <div class="borderBox">
    <ng-container *ngIf="isMobileView ; else desktopMenu">
      <div class="isMobileView d-flex flex-wrap align-items-center">

        <!-- Profile and Notification -->
        <div class="mobileNoticationAndProfile justify-content-between d-flex flex-row-reverse w-100">
          <ng-container *ngTemplateOutlet="profileAndNotification"></ng-container>
        </div>

        <!-- Category divs -->
        <div class="isMobileViewbox" *ngFor="let category of categories">
          <div class="nav-links-Mobile" (click)="navigateMobile(category)">
            <div class="links-Mobile" *ngIf="category.industry_name == 'Machine'">
              <img src="assets/images/new_img/machines.svg" class="logo" alt="">
              <span class="navtext"> Machines </span>
            </div>
            <div class="links-Mobile" *ngIf="category.industry_name == 'Services'">
              <img src="assets/images/new_img/services.svg" class="logo" alt="">
              <span class="navtext"> {{ category.industry_name }} </span>
            </div>
            <div class="links-Mobile" *ngIf="category.industry_name == 'Tools'">
              <img src="assets/images/new_img/tool.svg" class="logo" alt="">
              <span class="navtext"> Tools & Accessories </span>
            </div>
            <div class="links-Mobile" *ngIf="category.industry_name == 'Raw Material'">
              <img src="assets/images/new_img/raw.svg" class="logo" alt="">
              <span class="navtext"> Raw Materials </span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #desktopMenu>
      <nav class="navbar navbar-expand-lg">
        <div class="container-fluid p-0">
          <a class="navbar-brand user cursor-pointer" [routerLinkActive]="['active']" aria-current="page"
            [routerLink]="[homeScreen]">
            <img class="img1" src="assets/images/Raftaarr and efl logo_Final logo.png" alt="">
            <img class="img2" src="assets/images/App Logo.svg" alt="" width="32px">
          </a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#main_nav"
            aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse m-auto" id="main_nav">
            <ul class="nav m-auto">
              <li class="nav-item dropdown has-megamenu" *ngFor="let category of categories">
                <a class="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown"
                  (click)="selectCategory(category)">
                  <div *ngIf="category.industry_name == 'Machine'">
                    <img src="assets/images/new_img/machines.svg" class="logo" alt="">
                    <span class="navtext"> Machines </span>
                  </div>
                  <div *ngIf="category.industry_name == 'Services'">
                    <img src="assets/images/new_img/services.svg" class="logo" alt="">
                    <span class="navtext"> {{ category.industry_name }} </span>
                  </div>
                  <div *ngIf="category.industry_name == 'Tools'">
                    <img src="assets/images/new_img/tool.svg" class="logo" alt="">
                    <span class="navtext"> Tools & Accessories </span>
                  </div>
                  <div *ngIf="category.industry_name == 'Raw Material'">
                    <img src="assets/images/new_img/raw.svg" class="logo" alt="">
                    <span class="navtext"> Raw Materials </span>
                  </div>

                </a>
                <div class="dropdown-menu megamenu" role="menu" (click)="onDropdownMenuClick($event)" #dropdownMenu>
                  <div class="row">
                    <!-- Sidebar Navigation -->
                    <div class="col-md-3" *ngIf="selectedParams.industryId">
                      <ul class="nav  sidebar" id="style-3">

                        <li *ngFor="let subCategory1 of AllSubCategory1" (click)="selectSubCategory1(subCategory1)"
                          [class.active]="selectedParams.subCategory1Id === subCategory1.id">

                          <img [src]="subCategory1?.Media?.[0]?.url" alt="Image">
                          <span>{{ subCategory1.title }}</span>
                          <span *ngIf="selectedParams.subCategory1Id === subCategory1.id" class="showdivactive">
                            <img src="assets/images/new_img/arrow.svg" alt="">
                          </span>
                        </li>
                        <!-- <div *ngIf="guestUser" class="cursor-pointer chats" (click)="Login()"
                          [ngClass]="{'d-none disabled-image': isCompanyInterest==false }" class="headerpic imgc">
                          <img class="" width="30px" src="assets/images/new_img/users.svg" alt="user">
                        </div> -->
                        <!-- <div class="dropdown">
                          <button *ngIf="!guestUser" type="button" class="me-sm-2 me-0 menu1 headerpic imgc" href="#"
                            role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false"
                            [disabled]="isCompanyInterest==true"
                            [ngStyle]="isCompanyInterest==false ? {'cursor': 'allowed', 'opacity': 1}:{'cursor':'pointer', 'background': 'transparent !important' }">
                            <img class="" width="30px" src="assets/images/new_img/Notification.png" alt="notify">
                            <span *ngIf="NotificationAll?.length > 0"
                              class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger custom-noti">
                              {{ resultNotification[0]?.totalCount }}
                              <span class="visually-hidden">unread notifications</span>
                            </span>
                          </button>
                          <ul class="Notificationbox dropdown-menu p-4" aria-labelledby="dropdownMenuLink"
                            (scroll)="onScroll($event)" [ngStyle]="{
                  'height': NotificationAll?.length === 0 ? '100px' : '350px'
                }">
                            <div class="d-flex justify-content-between">
                              <h4 class="headNotifications"> Notifications</h4>
                              <span class="redColor"> {{totalCount}} New</span>
                            </div>
                            <li class="d-flex align-items-start cursor-pointer"
                              *ngFor="let item of NotificationAll; let i=index" (click)="markAsRead(item,i)"
                              [ngClass]="{'unread-notification': item?.status === 0}">
                              <div class="Notificationsbox">
                                <div class="datebox"><span>{{item?.date}}</span></div>
                                <h5> <span class="redcircle" *ngIf="item?.status === 0"></span>
                                  {{item?.title}}
                                  <span class="timenoti">
                                    {{item?.time}}
                                  </span>
                                </h5>
                                <p> {{item?.text}}</p>
                              </div>
                            </li>
                           
                          </ul>
                        </div>
                        <div class="dropdown">
                          <button *ngIf="!guestUser" type="button" class="me-0 menu1 bgcolorhide" href="#" role="button"
                            id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false"
                            [disabled]="isCompanyInterest==true"
                            [ngStyle]="isCompanyInterest==false ? {'cursor': 'allowed', 'opacity': 1}:{'cursor':'pointer', 'background': 'transparent !important'}"
                            class="headerpic imgc">
                            <img *ngIf="headerPic; else staticImage" [src]="headerPic" alt="user" width="40px">
                            <ng-template #staticImage>
                              <img src="assets/images/profileView.webp" alt="user" width="40px" class="headerpic">
                            </ng-template>

                          </button>
                          <ul class="dropdown-menu p-4" aria-labelledby="dropdownMenuLink">
                            <li class="d-flex align-items-start cursor-pointer" (click)="dashboard()">
                              <a class="dropdown-item">
                                <h4 class="mb-0"> Dashboard </h4>
                              </a>
                            </li>
                            <li class="d-flex align-items-start cursor-pointer" (click)="myProfile()">
                              <a class="dropdown-item">
                                <h4 class="mb-0">My Profile</h4>
                              </a>
                            </li>
                            <li class="d-flex align-items-start cursor-pointer" (click)="MyListings()">
                              <a class="dropdown-item">
                                <h4 class="mb-0"> My Listings </h4>
                              </a>
                            </li>
                            <li class="d-flex align-items-start cursor-pointer" (click)="myRequirement()">
                              <a class="dropdown-item">
                                <h4 class="mb-0"> Requirement </h4>
                              </a>
                            </li>
                            <li class="d-flex align-items-start cursor-pointer" (click)="MyWishlist()">
                              <a class="dropdown-item">
                                <h4 class="mb-0"> My Wishlist </h4>
                              </a>
                            </li>
                            <li class="d-flex align-items-start cursor-pointer" (click)="Enquiries()">
                              <a class="dropdown-item">
                                <h4 class="mb-0"> Enquiries </h4>
                              </a>
                            </li>
                            <li class="d-flex align-items-start cursor-pointer" (click)="SettingsPreferences()">
                              <a class="dropdown-item">
                                <h4 class="mb-0"> Settings & Preferences </h4>
                              </a>
                            </li>
                            <li class="d-flex align-items-start mb-0 cursor-pointer" (click)=" logout()">
                              <a class="dropdown-item">
                                <h4 class="mb-0" style="color: #EF0A0A !important"> Logout </h4>
                              </a>
                            </li>
               
                          </ul>
                        </div> -->


                        <!-- <li *ngFor="let subCat of subCategoryData"
                          [class.active]="selectedSubCategory === subCat.sub_category_name">
                          <p class="linksub" (click)="selectSubCategory(subCat.id)">
                            <img src="assets/images/new_img/metal.svg" class="logo" alt="">
                            <span>{{ subCat.sub_category_name }}</span>
                            <span *ngIf="selectedSubCategory === subCat.sub_category_name" class="showdivactive">
                              <img src="assets/images/new_img/arrow.svg" class="">
                            </span>
                          </p>
                        </li> -->
                      </ul>
                    </div>
                    <!-- Product Grid -->
                    <div class="col-md-9">
                      <!-- <div class="btn-group shubfillternav pt-3" role="group">
                        <button type="button" class="btnblue" [ngClass]="{ 'active': selectedFilter === 'All' }"
                          (click)="selectFilter('All')">All</button>
                        <button type="button" class="btnblue" [ngClass]="{ 'active': selectedFilter === 'Made in India' }"
                          (click)="selectFilter('Made in India')">Made in India</button>
                        <button type="button" class="btnblue" [ngClass]="{ 'active': selectedFilter === 'Imported' }"
                          (click)="selectFilter('Imported')">Imported</button>
                      </div> -->
                      <!-- Iterate over subCategoryData to display products -->
                      <div>
                        <div>
                          <div class="row product-grid" *ngIf="selectedParams.subCategory1Id">
                            <ul class="sub_category">
                              <li *ngFor="let subCategory2 of AllSubCategory2"
                                (click)="selectSubCategory2(subCategory2,dropdownMenu)"
                                [class.selected]="selectedParams.subCategory2Id === subCategory2.id" class="sub-cat">
                                {{ subCategory2.title }}
                              </li>
                            </ul>

                            <!-- View All Section -->
                            <!-- <div class="col-md-2">
                              <div class="product-card p-0">
                                <div class="navBarmenuimg p-0" style="height: 160px;">
                                  <a (click)="navigateToProductListing(this.industry,dropdownMenu)">
                                    <img
                                      src="https://raftaar-dev.s3.ap-south-1.amazonaws.com/1732186043132-638581051-popularCategory4.png"
                                      class="logo" alt="" style="border-radius: 8px;">
                                    <p class="view-all-text" style="border-radius: 8px;">view all</p>
                                  </a>
                                </div>
  
                              </div>
                            </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <!-- Notification and Profile Veiw -->
              
            </ul>
            <ng-container *ngTemplateOutlet="profileAndNotification"></ng-container>
            <!-- <ul class="navbar-nav ms-auto">
             
            </ul> -->
          </div> <!-- navbar-collapse.// -->
        </div> <!-- container-fluid.// -->
      </nav>
    </ng-template>

    <div class="searchBox p-3 pt-0">
      <form class="d-flex me-md-4 me-3">
        <div class="search-container">
          <div class="search">
            <input #searchInput [formControl]="searchControls" class="form-control " type="search"
              [placeholder]="searchPlaceholder" aria-label="Search" [disabled]="isCompanyInterests === false"
              (input)="onSearch($event)" (focus)="fetchRecentSearches()">
            <img src="assets/images/new_img/search.svg" class="searchicon" style="margin-top: 3px;">
          </div>

          <div class="Locationbox" (click)="toggleLocationBox()">
            <p>
              <span>
                <img src="assets/images/locations.svg" class="img-fluid" alt="location" />
              </span>
              <span class="locationpick"> Search by Location</span>
              <span class="locationpickname" *ngIf="selectedLocation"> - {{ selectedLocation.name || selectedLocation
                }}</span>
            </p>
          </div>
          <div *ngIf="showLocationBox" class="location-box DropdownCars"
            (window:mouseup)="autoCloseForDropdownCars($event)">
            <h4>Location</h4>
            <div class="location-list">
              <div *ngFor="let location of locations" class="location-item" (click)="selectLocation(location)">
                <img [src]="location.icon" [alt]="location.name" />
                <p>{{ location.name }}</p>
              </div>
            </div>
          </div>
          <div class="SearchBtnCta1">
            <button [disabled]="!selectedLocation && !searchControls.value?.trim()" type="submit" class="SearchBtnCta"
              (click)="stateVaule(selectedLocation?.name, searchControls.value)">Search</button>
          </div>
          <ul *ngIf="filteredResults2.length > 0 || recentSearches.length > 0"
            class="predictive-search-list DropdownCars1" #dropdownList>
            <li *ngFor="let result of filteredResults2"
              (click)="stateVaule(selectedLocation?.name,result?.Category3?.title)"> {{
              result?.Category3?.title}}</li>

            <li *ngIf="recentSearches.length > 0" class="recent-search-title">
              <h6 class="recent-search-tab-title">Recent Searches</h6>
            </li>
            <li *ngFor="let search of recentSearches" (click)="stateVaule(selectedLocation?.name,search?.title)">
              {{ search.title }}
            </li>
          </ul>
          <ng-template #noDataFound>
            <ul class="predictive-search-list">
              <li>No data found</li>
            </ul>

          </ng-template>

          <div *ngIf="filteredResults2.length === 0 && searchControls.value && filteredResults2 !== null">
            <ng-container *ngTemplateOutlet="noDataFound"></ng-container>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Profile and Notifications Div template -->
<ng-template #profileAndNotification>
  <div *ngIf="guestUser" class="cursor-pointer chats" (click)="Login()"
    [ngClass]="{'d-none disabled-image': isCompanyInterest==false }" class="headerpic imgc">
    <img class="" width="30px" src="assets/images/new_img/users.svg" alt="user">
  </div>
  <div class="dropdown">
    <button *ngIf="!guestUser" type="button" class="me-sm-2 me-0 menu1 headerpic imgc" href="#" role="button"
      id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false" [disabled]="isCompanyInterest==true"
      [ngStyle]="isCompanyInterest==false ? {'cursor': 'allowed', 'opacity': 1}:{'cursor':'pointer', 'background': 'transparent !important' }">
      <img class="" width="30px" src="assets/images/new_img/Notification.png" alt="notify">
      <span *ngIf="NotificationAll?.length > 0"
        class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger custom-noti">
        {{ resultNotification[0]?.unReadCount > 99 ?  '99+': resultNotification[0]?.unReadCount }}
        <span class="visually-hidden">unread notifications</span>
      </span>
    </button>
    <ul class="Notificationbox dropdown-menu p-4" aria-labelledby="dropdownMenuLink" (scroll)="onScroll($event)"
      [ngStyle]="{
                  'height': NotificationAll?.length === 0 ? '100px' : '350px'
                }">
      <div class="d-flex justify-content-between">
        <h4 class="headNotifications"> Notifications</h4>
        <span class="redColor"> {{totalCount}} New</span>
      </div>
      <li class="d-flex align-items-start cursor-pointer" *ngFor="let item of NotificationAll; let i=index"
        (click)="markAsRead(item,i)" [ngClass]="{'unread-notification': item?.status === 0}">
        <div class="Notificationsbox">
          <div class="datebox"><span>{{item?.date}}</span></div>
          <div class="d-flex">
            <span class="redcircle" *ngIf="item?.status === 0"></span>
            <h5> 
              <b>{{item?.title}}</b>
              <span class="timenoti">
                {{item?.time}}
              </span>
            </h5>
          </div>
          
          <ng-container *ngIf="getNotificationTextParts(item) as notificationData">
            <p>
              {{ notificationData.prefix }}
              <a href="javascript:void(0)" (click)="viewSingleProduct(notificationData.product_id)" *ngIf="notificationData.product">
                "{{ notificationData.product }}"
              </a>{{ notificationData.suffix }}
            </p>
          </ng-container>
          
        </div>
      </li>
      <!-- <li *ngIf="isLoading" class="text-center">
                    <p>Loading...</p>
                  </li> -->
    </ul>
  </div>
  <div class="dropdown">
    <button *ngIf="!guestUser" type="button" class="me-0 menu1 bgcolorhide" href="#" role="button" id="dropdownMenuLink"
      data-bs-toggle="dropdown" aria-expanded="false" [disabled]="isCompanyInterest==true"
      [ngStyle]="isCompanyInterest==false ? {'cursor': 'allowed', 'opacity': 1}:{'cursor':'pointer', 'background': 'transparent !important'}"
      class="headerpic imgc">
      <img *ngIf="headerPic; else staticImage" [src]="headerPic" alt="user" width="40px">
      <ng-template #staticImage>
        <img src="assets/images/profileView.webp" alt="user" width="40px" class="headerpic">
      </ng-template>

      <!-- <img class="" width="30px" height="30px" src="assets/images/new_img/user-profile.svg" alt="user"> -->
    </button>
    <ul class="dropdown-menu p-4" aria-labelledby="dropdownMenuLink">
      <li class="d-flex align-items-start cursor-pointer" (click)="dashboard()">
        <a class="dropdown-item">
          <h4 class="mb-0"> Dashboard </h4>
        </a>
      </li>
      <li class="d-flex align-items-start cursor-pointer" (click)="myProfile()">
        <a class="dropdown-item">
          <h4 class="mb-0">My Profile</h4>
        </a>
      </li>
      <li class="d-flex align-items-start cursor-pointer" (click)="MyListings()">
        <a class="dropdown-item">
          <h4 class="mb-0"> My Listings </h4>
        </a>
      </li>
      <li class="d-flex align-items-start cursor-pointer" (click)="myRequirement()">
        <a class="dropdown-item">
          <h4 class="mb-0"> Requirement </h4>
        </a>
      </li>
      <li class="d-flex align-items-start cursor-pointer" (click)="MyWishlist()">
        <a class="dropdown-item">
          <h4 class="mb-0"> My Wishlist </h4>
        </a>
      </li>
      <li class="d-flex align-items-start cursor-pointer" (click)="Enquiries()">
        <a class="dropdown-item">
          <h4 class="mb-0"> Enquiries </h4>
        </a>
      </li>
      <li class="d-flex align-items-start cursor-pointer" (click)="SettingsPreferences()">
        <a class="dropdown-item">
          <h4 class="mb-0"> Settings & Preferences </h4>
        </a>
      </li>
      <li class="d-flex align-items-start mb-0 cursor-pointer" (click)=" logout()">
        <a class="dropdown-item">
          <h4 class="mb-0" style="color: #EF0A0A !important"> Logout </h4>
        </a>
      </li>
      <!-- <li class="d-flex align-items-start" [routerLink]="['/main/profile/ads']">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M4.40476 15.5264L8.93476 20.0564C10.7948 21.9164 13.8148 21.9164 15.6848 20.0564L20.0748 15.6664C21.9348 13.8064 21.9348 10.7864 20.0748 8.91637L15.5348 4.39637C14.5848 3.44637 13.2748 2.93637 11.9348 3.00637L6.93476 3.24637C4.93476 3.33637 3.34476 4.92637 3.24476 6.91637L3.00476 11.9164C2.94476 13.2664 3.45476 14.5764 4.40476 15.5264Z"
                      stroke="#0D0849" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                      d="M9.73438 12.2266C11.1151 12.2266 12.2344 11.1073 12.2344 9.72656C12.2344 8.34585 11.1151 7.22656 9.73438 7.22656C8.35366 7.22656 7.23438 8.34585 7.23438 9.72656C7.23437 11.1073 8.35366 12.2266 9.73438 12.2266Z"
                      stroke="#0D0849" stroke-width="1.25" stroke-linecap="round" />
                    <path d="M13.2344 17.2266L17.2344 13.2266" stroke="#0D0849" stroke-width="1.25" stroke-miterlimit="10"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <a class="dropdown-item">
                    <h4 class="mb-0">Ads</h4>
                    <p>Pellentesque vivamus nulla est, </p>
                  </a>
                </li> -->
    </ul>
  </div>
</ng-template>